import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { useMediaTableContext } from '../../../hooks';

import { VpTabButtonGroup } from '../../components';

import VpMediaInfoMenu from '../../widgets/VpMediaTable/VpMediaInfoMenu';
import VpAttachmentInfoMenu from '../../widgets/VpMediaTable/VpAttachmentInfoMenu';
import VpMediaInfoPreview from './VpMediaInfoPreview';
import VpMediaInfoDetails from './VpMediaInfoDetails';
import CustomizeThumbnailButton from '../../components/CustomizeThumbnailButton/CustomizeThumbnailButton';

const boxStyles = {
  flex: 1,
  padding: '25px'
};
const stackStyles = {
  height: '100%'
};

const VpMediaInfo = ({ media }) => {
  const isVideo = !!media?.mediaId;
  const mediaId = media?.mediaId || media?.attachmentId;
  const [isShowingDetails, setIsShowingDetails] = useState(false);

  const { setUpdatingThumbnail } = useMediaTableContext();

  const handleCustomizeThumbnail = () => setUpdatingThumbnail(mediaId);

  return (
    <Box sx={boxStyles}>
      <Stack gap={5} sx={stackStyles}>
        <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between">
          <VpTabButtonGroup
            first="Preview"
            second="Details"
            onSelect={setIsShowingDetails}
            selected={isShowingDetails}
          />
          <Stack direction="row" gap="5px">
            {isVideo && <CustomizeThumbnailButton onClick={handleCustomizeThumbnail} />}
            {isVideo ? <VpMediaInfoMenu media={media} /> : <VpAttachmentInfoMenu media={media} />}
          </Stack>
        </Stack>
        {isShowingDetails ? (
          <VpMediaInfoDetails key={mediaId} media={media} />
        ) : (
          <VpMediaInfoPreview key={mediaId} media={media} />
        )}
      </Stack>
    </Box>
  );
};

VpMediaInfo.propTypes = {
  media: PropTypes.shape({
    mediaId: PropTypes.string,
    attachmentId: PropTypes.string
  })
};
export default VpMediaInfo;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfo.jsx